import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import './RiskAssessment.css';

const RiskAssessment = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('pages.riskAssessment.pageTitle');
  }, [t]);

  const breadcrumbs = [
    { labelKey: 'nav.services', href: '/#services' },
    { labelKey: 'services.riskAssessment' }
  ];

  return (
    <PageTemplate 
      titleKey="pages.riskAssessment.title"
      subtitleKey="pages.riskAssessment.subtitle"
      breadcrumbs={breadcrumbs}
    >
      {/* 顶部CTA区域 */}
      <div className="risk-assessment-cta-top">
        <a href="/connect-us" className="cta-button-primary">
          {t('pages.riskAssessment.cta.primary')}
        </a>
      </div>

      {/* 核心价值区域 */}
      <div className="why-choose-section">
        <h2>{t('pages.riskAssessment.whyChoose.title')}</h2>
        <p className="highlight-text">
          {t('pages.riskAssessment.whyChoose.highlight')}
        </p>
        <p className="description-text">
          {t('pages.riskAssessment.whyChoose.description')}
        </p>
      </div>

      {/* 服务价值主张 */}
      <div className="value-proposition-section">
        <h2>{t('pages.riskAssessment.valueProposition.title')}</h2>
        <div className="advantages-grid">
          {[1, 2, 3].map((num) => (
            <div key={num} className="advantage-card">
              <h3>{t(`pages.riskAssessment.valueProposition.advantage${num}.title`)}</h3>
              <p>{t(`pages.riskAssessment.valueProposition.advantage${num}.description`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 专业领域 */}
      <div className="expertise-section">
        <h2>{t('pages.riskAssessment.expertise.title')}</h2>
        <div className="expertise-grid">
          {[1, 2, 3, 4].map((num) => (
            <div key={num} className="expertise-card">
              <h3>{t(`pages.riskAssessment.expertise.area${num}.title`)}</h3>
              <p>{t(`pages.riskAssessment.expertise.area${num}.description`)}</p>
              <div className="keywords">
                {t(`pages.riskAssessment.expertise.area${num}.keywords`)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 方法论 - 四步法 */}
      <div className="methodology-section">
        <h2>{t('pages.riskAssessment.methodology.title')}</h2>
        <div className="methodology-timeline">
          {[1, 2, 3, 4].map((num, index) => (
            <React.Fragment key={num}>
              <div className="methodology-step">
                <div className="step-number">{num}</div>
                <h3>{t(`pages.riskAssessment.methodology.step${num}.title`)}</h3>
                <p className="step-slogan">{t(`pages.riskAssessment.methodology.step${num}.slogan`)}</p>
                <p className="step-description">{t(`pages.riskAssessment.methodology.step${num}.description`)}</p>
              </div>
              {/* {index < 3 && <div className="step-arrow">→</div>} */}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* 统计数据区域 */}
      <div className="stats-section">
        <h2>{t('pages.riskAssessment.stats.title')}</h2>
        <div className="stats-grid-modern">
          {[1, 2, 3, 4].map((num) => (
            <div key={num} className="stat-card">
              <div className="stat-number">{t(`pages.riskAssessment.stats.stat${num}.number`)}</div>
              <div className="stat-label">{t(`pages.riskAssessment.stats.stat${num}.label`)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 最终行动召唤 */}
      <div className="final-cta-section">
        <h2>{t('pages.riskAssessment.callToAction.title')}</h2>
        <p>{t('pages.riskAssessment.callToAction.description')}</p>
        <a href="/connect-us" className="cta-button-large">
          {t('pages.riskAssessment.callToAction.button')}
        </a>
      </div>
    </PageTemplate>
  );
};

export default RiskAssessment;
